import { render, staticRenderFns } from "./VersionDialogComponent.vue?vue&type=template&id=46b25188"
import script from "./VersionDialogComponent.vue?vue&type=script&lang=js"
export * from "./VersionDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports